import { ShieldCheck, Sparkles, Scissors } from "lucide-react";
import { LineArtLady } from "./LineArt";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";
import { IMAGES } from "../data/site";

const VALUES = [
  {
    icon: ShieldCheck,
    title: "Serene Privacy",
    text: "A ladies-only sanctuary where comfort and discretion come first.",
  },
  {
    icon: Sparkles,
    title: "Tailored Aesthetics",
    text: "Every service is personalised to your style, skin and hair.",
  },
  {
    icon: Scissors,
    title: "Master Stylists",
    text: "Experienced artists devoted to precision and detail.",
  },
];

export const About = () => (
  <section id="about" data-testid="about-section" className="relative scroll-mt-20 overflow-hidden bg-[#E3DECF] py-24 sm:py-28">
    <LineArtLady className="pointer-events-none absolute -left-16 bottom-0 w-[380px] text-[#454538] opacity-[0.06]" />

    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHeading
        eyebrow="About Us"
        title="A Sanctuary of Beauty, Crafted for Her"
      />

      <div className="mt-16 grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
        <Reveal>
          <p className="font-body text-base leading-relaxed text-[#383D33]/85">
            Tucked away on Damascus Street in Al Qusais, Her Styles Ladies Salon is a
            refined escape from the pace of the city. Step inside and the world softens:
            warm light, gentle fragrance, and a team that makes every visit feel special,
            not routine.
          </p>
          <p className="mt-5 font-body text-base leading-relaxed text-[#383D33]/85">
            From transformative hair colour and nourishing spa therapies to bridal artistry
            and calming massages, our specialists bring years of craft to every chair.
            Premium products, immaculate hygiene, and honest care. That is the Her Styles
            promise.
          </p>

          <div className="mt-10 grid gap-5 sm:grid-cols-3">
            {VALUES.map(({ icon: Icon, title, text }) => (
              <div
                key={title}
                className="rounded-2xl border border-[rgba(69,69,56,0.15)] bg-[#F5F2EB] p-5 transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-[rgba(201,162,75,0.6)]"
              >
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#454538]">
                  <Icon className="h-5 w-5 text-[#C9A24B]" />
                </div>
                <h3 className="mt-4 font-brand text-lg text-[#383D33]">{title}</h3>
                <p className="mt-2 font-body text-sm leading-relaxed text-[#383D33]/70">
                  {text}
                </p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={150}>
          <div className="relative mx-auto max-w-md lg:max-w-none">
            <div className="absolute -left-4 -top-4 h-full w-full rounded-3xl border border-[#C9A24B]" />
            <img
              src={IMAGES.aboutMain}
              alt="Styling chairs and mirrors inside Her Styles Ladies Salon"
              loading="lazy"
              className="relative h-[420px] w-full rounded-3xl object-cover shadow-2xl sm:h-[500px]"
            />
            <img
              src={IMAGES.aboutSecondary}
              alt="Wash stations and styling chairs inside Her Styles Ladies Salon"
              loading="lazy"
              className="absolute -bottom-10 -right-4 hidden w-44 rounded-2xl border-4 border-[#E3DECF] object-cover shadow-xl sm:block lg:-right-10 lg:w-56"
            />
            <div className="absolute -bottom-6 left-6 rounded-2xl bg-[#383D33] px-6 py-4 shadow-xl sm:left-10">
              <p className="font-brand text-lg text-[#C9A24B]">Her Styles</p>
              <p className="font-body text-[10px] font-medium uppercase tracking-[0.35em] text-[#F2EFE6]/80">
                Ladies Salon
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
